import React from 'react';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../ui/dropdown-menu';

import { cn } from '../../lib/utils';

const NewDropDown = ({ items = [], trigger, className }) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" className="outline-none p-0 m-0">
          {trigger}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent sideOffset={4} className={cn('w-[200px] rtl:ml-2 ltr:mr-2 bg-white', className)}>
        {items?.map((item, index) => (
          <DropdownMenuItem
            key={index}
            onSelect={e => {
              item.onClick?.();
            }}
            className={cn(
              'm-0 cursor-pointer hover:bg-gray-100 rounded-md rtl:flex-row-reverse ltr:flex-row',
              item.className
            )}
          >
            {item.icon}
            <span>{item.text}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NewDropDown;
